var baseURL;
if(process.env.NODE_ENV == 'development'){
//  baseURL = 'http://wisdom.consec.top:8000/'
 baseURL ='http://localhost:8000/'   //修改ajax接口
  // baseURL = 'http://117.73.4.21:8000/'
} else {
  baseURL = 'http://wisdom.consec.top:8000/'
  //baseURL ='http://192.168.118.112:8000'
  // baseURL = 'http://117.73.4.21:8000/'
}

export default baseURL;



// WEBPACK FOOTER //
// ./src/config/host.js